import angular from 'angular';

import { unitPopupRoutesConfig } from './unit.popup.routes';

export default angular
  .module('unit.popup', ['ui.router'])
  .config(unitPopupRoutesConfig);
